module.exports = __webpack_public_path__ + "static/media/Help Me Stand.3a5c441d.jpg";